const w =
  typeof window === 'undefined'
    ? {
        localStorage: {
          getItem: () => {},
          setItem: () => {},
          addEventListener: () => {}
        },
        sessionStorage: {
          getItem: () => {},
          setItem: () => {},
          addEventListener: () => {}
        }
      }
    : window;

// This would eventually need to be some sort of cross domain storage, but for
// now, use localStorage
const { localStorage, sessionStorage } = w;

const addStorageEventListener = fn => {
  w.addEventListener('storage', fn);
};

export { addStorageEventListener, localStorage, sessionStorage };
